import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { message, Modal, Spin } from 'antd';


import CollateralStatus from '../../components/CollateralStatus';
import Collateralize from '../../components/Collateralize';
import Pledge from '../../components/Pledge';
import SuccessCollateralized from '../../components/SuccessCollateralized';
import {
	// BLUE_COG_SETTINGS_ICON,
	// XHT_HAND_ICON,
	GOING_PUBLIC_COLLATERAL_GLOBE,
	CLOUD_COLLATERAL_COVERED,
	GOING_PUBLIC_COLLATERAL_GLOBE_GREEN
} from '../../config/media';
// import Comments from '../../components/Comments';
import { COLLATERAL_TOTAL_AMOUNT } from '../../config/constants';
import {
	getCollateral,
	putExchange,
	withdrawXht,
	pledgeXht,
	getStakeAll
	// getExchangeMsg,
	// postExchangeMsg,
	// deleteExchangeMsg
} from '../../common/fetch';
import CollateralModal from './CollateralModal';

import Wrapper from './style';

class Collateral extends Component {
	state = {
		isLoading: false,
		isOpen: false,
		step: 0,
		isOpenWithdraw: false,
		isFinish: false,
		id: undefined,
		msgs: [],
		page: 1,
		cmtIsLoading: false,
		showMore: false,
		viewOnCloud: false,
		type: "",
		cancelData: {},
		isVisible: false,
		CollateralStep: 1
	};

	componentDidMount() {
		const { exchange, history, location } = this.props;
		if (exchange.length === 0) {
			history.push('/');
		}
		if (exchange.length && location.search === '') {
			this.getData(exchange[0].id);
			// this.getMessage(exchange[0].id);
			this.setState({ id: exchange[0].id });
		} else {
			const id = location.search.split('=')[1];
			this.getData(id);
			// this.getMessage(id);
			this.setState({ id });
		}
	}

	getData = (id) => {
		this.setState(
			{
				isLoading: true
			},
			async () => {
				try {
					const res = await getCollateral(id);
					const { data } = res;
					this.props.actions.setCollateral(data);
					this.setState({ isLoading: false });
				} catch (error) {
					console.error(error);
				}
			}
		);
	};

	onPubilc = () => {
		const { is_public } = this.props.collateral;
		if (is_public) {
			message.info('This exchange is already public.');
			return;
		}
		// Modal.confirm({
		// 	title: 'Confirm to Set Public',
		// 	content:
		// 		'Once you make your exchange public, your exchange will be listed in public exchange list and others can pledge to your exchange. Your public profile information about your exchange will also be publicized. Keep in mind that a public exchange can not become private. Are you sure you want to make your exchange public?',
		// 	onOk: () => {
				this.setPublic();
		// 	},
		// 	onCancel() { }
		// });
	};

	setPublic = async () => {
		const { collateral, exchange } = this.props;
		const body = {
			id: collateral.id,
			is_public: true,
			info: {
				public: {
					title: collateral ? collateral.name : '',
					country: collateral && collateral.info  ? collateral.info.biz.DEFAULT_COUNTRY: '',
					url: collateral && collateral.info ? collateral.info.tech.EXCHANGE_CLIENT_URL : ''
				}
			}
		};
		try {
			await putExchange(body);
			this.props.actions.updateCollateral({ is_public: true });
			const newData = exchange.map((item) => {
				if (item.id === collateral.id) {
					const obj = { ...item };
					obj.is_public = true;
					return obj;
				}
				return item;
			});
			this.props.exchangeActions.readData(newData);
			this.setState({ isOpen: false });
			message.success('Success to set Public');
			this.props.history.push(`/project/${collateral.id}`)
		} catch (error) {
			console.error(error);
			message.error('Failed to set Public');
		}
	};

	onWithdraw = (type, cancelData) => {
		// const { collateral } = this.props;
		// if (collateral.is_collateralized) {
		// 	message.warn(
		// 		'Once the exchange is collateralized you can not withdraw your pledge for minimum of 6 months. You can read more here.'
		// 	);
		// 	return;
		// }
		// if (collateral.pledges.mine === 0) {
		// 	return;
		// }
		// Modal.confirm({
		// 	title: 'Withdraw Pledge',
		// 	content:
		// 		'You are about to with withdraw all of your pledged XHT. Are you sure you want to withdraw your pledge?" ',
		// 	onOk: () => {
		// 		this.backToWallet();
		// 	},
		// 	onCancel() { }
		// });
		this.setState({ cancelData })
		this.openModal(type);
	};

	requestPledges = async () => {
		try {
			// this.setState({ isLoading: true });
			const res = await getStakeAll();
			this.props.updateCollateral({ pledgesAll: res.data });
			// this.setState({ isLoading: false });
		} catch (err) {
			// this.setState({ isLoading: false });
		}
	}

	backToWallet = async () => {
		const { collateral, user } = this.props;
		const body = {
			exchange_id: collateral.id
		};
		try {
			await withdrawXht(body);
			const xht_available =
				parseFloat(user.balance.xht_available) +
				parseFloat(collateral.pledges.mine);
			this.props.actions.backCollateral(collateral.pledges.mine);
			this.props.userAction.updateData({ balance: { xht_available } });
			message.success('Success to withdraw pledge');
		} catch (error) {
			console.error(error);
			message.error('Failed to withdraw pledge');
		}
	};

	pledgXht = async (body) => {
		const { user } = this.props;
		try {
			await pledgeXht(body);
		} catch (error) {
			console.error(error);
			message.error('Failed to Pledge');
		}
		const xht_available =
			parseFloat(user.balance.xht_available) - parseFloat(body.amount);
		const total = body.amount + this.props.collateral.pledges.total;
		const states = {
			isOpen: false,
			isFinish: parseFloat(COLLATERAL_TOTAL_AMOUNT) <= total
		};
		this.setState(states, () => {
			this.props.userAction.updateData({ balance: { xht_available } });
			this.props.actions.addCollateral(body.amount);
			if (
				parseFloat(COLLATERAL_TOTAL_AMOUNT) >
				parseFloat(this.props.collateral.pledges.total)
			) {
				Modal.info({
					title: 'Success to plege',
					content: () => (
						<p>
							<b>You've Pledged: </b> {body.amount} XHT
						</p>
					)
				});
			} else {
				this.props.actions.updateCollateral({
					amount: COLLATERAL_TOTAL_AMOUNT,
					is_collateralized: true
				});
			}
		});
	};

	copy = (e) => {
		const copyText = e.target;
		/* Select the text field */
		if (copyText.tagName === 'INPUT') {
			copyText.select();
			copyText.setSelectionRange(0, 99999); /*For mobile devices*/

			/* Copy the text inside the text field */
			document.execCommand('copy');
			message.success('Copied!');
		}
	};

	openModal = (type) => {
		const { collateral } = this.props;
		if (collateral.is_collateralized) {
			return;
		}
		this.setState({ isOpen: true, type });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	hidePopup = () => {
		this.setState({ isFinish: false });
	};

	handleShowMore = () => {
		this.setState({ showMore: !this.state.showMore });
	};

	handleViewOnCloud = () => {
		this.setState({ viewOnCloud: true });
	};

	renderPopup = () => {
		const { isOpen, type, cancelData } = this.state
		const { collateral, exchange } = this.props;
		const { mine } = collateral.pledges || {};
		if (!isOpen) return null;
		if (type === "collateralize") {
			return (
				<Collateralize
					visible={isOpen}
					exchange={exchange[0]}
					collateral={collateral}
					onOk={(body) => {
						this.pledgXht(body);
					}}
					onCancel={this.closeModal}
					onCollateralCallback={this.getData}
				/>
			);
		} else {
			return (
				<Pledge
					visible={isOpen}
					amount={mine}
					exchange={exchange[0]}
					collateral={collateral}
					cancelData={cancelData}
					onOk={(body) => {
						this.pledgXht(body);
					}}
					type={type}
					onCancel={this.closeModal}
					getStakeAllData={this.requestPledges}
				/>
			);
		}
	};

	goToPublic = () => {
		// this.props.history.push(`/project/${this.props.collateral.id}`);
		this.props.history.push(`/project`);
	};
	
	goToWallet = () => {
		this.props.history.push(`/wallet`);
	};

	handleShowModal = () => {
		this.setState({ isVisible: true })
	}

	handleCancelModal = () => {
		this.setState({ isVisible: false, CollateralStep: 1 })
	}

	handleStep = (CollateralStep) => {
		this.setState({ CollateralStep })
	}
 
	render() {
		const { isFinish, isLoading, showMore, viewOnCloud, isVisible, CollateralStep } = this.state;
		const { exchange } = this.props;
		if (exchange.length === 0) {
			return null;
		}
		const exchangeData = exchange[0];

		return (
			<Wrapper>
				{/* <div className="main-header">
					Collateral
				</div> */}
				<div className="main-panel">
					<div className="flex-between">
						<h2>Exchange staking collateral</h2>
						<div className="flex-center">
							<div className="text-end">
								<div>
									<span className="title">Visibility:</span>{' '}
									<span
										className={exchangeData.is_public ? "public" : ""}
									>
										{exchangeData.is_public ? 'Public' : 'Private'}
									</span>
								</div>
								{exchangeData.is_public
									?
									<span
										className="configure-link"
										onClick={this.goToPublic}
									>
										Visit public page
										</span>
									: <span className="configure-link" onClick={this.handleShowModal}>Configure</span>
								}
							</div>
							<div>
								{exchangeData.is_public
									?
									<img src={GOING_PUBLIC_COLLATERAL_GLOBE_GREEN} className="user-xht" alt="user-profile-xht" />
									:
									<img src={GOING_PUBLIC_COLLATERAL_GLOBE} className="user-xht" alt="user-profile-xht" />
								}
							</div>
						</div>
					</div>
					<p style={{ maxWidth: 789 }}>
						Anyone can use the HollaEx Kit to run an exchange for free without collateral but for those that do stake XHT they can increase the profit margins from trading fees generated from the exchange operations as well as other benefits.
					</p>
					{showMore
						? <div>
							<p>
								<b>Advantages for collateralizing:</b>
								<span className="advatages">
									• Earn passive income from your exchange trading fees
								{/* <a
									title="forum link"
									target="_blank"
									rel="noopener noreferrer"
									href="https://info.hollaex.com/hc/en-us/articles/360040098633-What-is-the-Wave-Auction-"
								>
									Wave Auction
								</a> */}
								</span>
								<span className="advatages">
									• Earn passive income from the whole network trading fees
							</span>
								<span className="advatages">
									• Obtain XHT distribution from newly minted token
							</span>
								<span className="advatages">
									• Make your exchange public and crowd-fund your exchange
							</span>
							</p>
							<p style={{ maxWidth: 440 }}>
								To start{' '}
								<span className="configure-link" onClick={this.goToWallet}>charge your wallet</span>{' '}
							balance with XHT and stake XHT on your exchange or search for a{' '}
								<span className="configure-link" onClick={this.goToPublic}>public project</span>{' '}
							to stake XHT on.
						</p>
						</div>
						: null
					}
					<div>
						<span
							className="configure-link"
							onClick={this.handleShowMore}
						>
							{showMore ? 'View less' : 'Learn more'}
						</span>
					</div>
					<div>
						{exchangeData.type === "Cloud"
							&& !viewOnCloud
							? <div className="text-center">
								<img src={CLOUD_COLLATERAL_COVERED} className="user-xht" alt="user-profile-xht" />
								<div className="collateral-description">
									<div>Collateral is required for becoming an exchange member in HollaEx Network where you can issue assets and receive other benefits.</div>
									<div>You or anyone can add more XHT collateral stake on your exchange which will increase your exchange's profit margins and more.</div>
								</div>
								<span
									className="collateral-description configure-link"
									onClick={this.handleViewOnCloud}
								>
									View collateral details
							</span>
							</div>
							: <div className="collateral">
								{isLoading ? (
									<Spin />
								) : (
										<CollateralStatus
											exchange={exchangeData}
											onPledged={this.openModal}
											onPubilc={this.onPubilc}
											onWithdraw={this.onWithdraw}
											onCopy={this.copy}
										/>
									)}
							</div>
						}
					</div>
				</div>
				<SuccessCollateralized
					visible={isFinish}
					onOk={this.hidePopup}
					onCancel={this.hidePopup}
				/>
				{this.renderPopup()}
				<CollateralModal
					isVisible={isVisible}
					exchangeData={exchangeData}
					step={CollateralStep}
					handleStep={this.handleStep}
					onOk={this.onPubilc}
					handleClose={this.handleCancelModal}
				/>
			</Wrapper>
		);
	}
}

export default Collateral;
